import { Controller } from "@hotwired/stimulus"

// Horizontal photo stripe — native touch swipe, pointer-drag on desktop
// after a short threshold, arrow keys when focused. Click (not drag)
// must reach the inner [data-gallery] links so Story Assets modal gallery
// can open. Pointer capture is delayed until the pointer actually moves,
// otherwise the click is retargeted to the stripe and the lightbox never
// appears.
export default class extends Controller {
  start(event) {
    if (event.pointerType === "touch") return
    if (event.button !== 0) return
    this.dragging = true
    this.moved = false
    this.startX = event.clientX
    this.startScroll = this.element.scrollLeft
  }

  move(event) {
    if (!this.dragging) return
    const dx = event.clientX - this.startX
    if (Math.abs(dx) <= 6) return
    if (!this.moved) {
      this.moved = true
      this.element.classList.add("is-dragging")
      this.element.setPointerCapture(event.pointerId)
    }
    this.element.scrollLeft = this.startScroll - dx
  }

  end(event) {
    this.dragging = false
    this.element.classList.remove("is-dragging")
    if (event.type === "pointercancel") this.moved = false
  }

  click(event) {
    if (this.moved) {
      event.preventDefault()
      event.stopPropagation()
    }
    this.moved = false
  }

  keydown(event) {
    if (document.querySelector(".modal.opened")) return
    const item = this.element.querySelector(".bld-castle__gallery-item")
    if (!item) return
    const gap = parseFloat(getComputedStyle(this.element).gap) || 0
    const step = item.getBoundingClientRect().width + gap
    if (event.key === "ArrowRight") {
      event.preventDefault()
      this.element.scrollBy({ left: step, behavior: "smooth" })
    } else if (event.key === "ArrowLeft") {
      event.preventDefault()
      this.element.scrollBy({ left: -step, behavior: "smooth" })
    }
  }
}
